import React, { useEffect, useState } from "react";
import s from "./pages.module.scss"
import Main from "./main/main";
import AboutProduct from "./about-product/about-product";
import SituableFor from "./situable-for/situable-for";
import InfoSource from "./info-source/info-source";
import DemonstrationProduct from "./demonstration-product/demonstration-product";
import MediamonitoringOnline from "./medimonitoring-online/mediamonitoring-online";
import Advantages from "./advantages/advantages";
import Partners from "./partners/partners";
import ContactsPage from "./contacts/contacts";
import Offert from "./offert/offert";
import PrivacyPolicy from "./privacy-policy/privacy-policy";
import Signin from "pages/authorization/signin/signin";

const Pages = (props) => {

    const [headerHeight, setHeaderHeight] = useState(152);
    const [pageHeight, setPageHeight] = useState(window.innerHeight - headerHeight);
    const [isShowDemo, setIsShowDemo] = useState(props.isShowDemo);
    
    useEffect(() => {
        setIsShowDemo(props.isShowDemo);
        addEventListener("resize", (event) => {
            setPageHeight(window.innerHeight - headerHeight);
        });
    }, [props.isShowDemo])

    const setShowDemo = () => {
        props.setIsShowDemo(!isShowDemo);
    }

    const handleScroll = (e) => {
        let el = document.querySelector("#Pages")
    }

    const setSignIn = (login, password) => {
        props.signin(login, password, props.authLanguage);
    }
    
    const pages =   <div id={'Pages'} className={s.Pages} onScroll={handleScroll}>
                        <div id={"main"} className={s.Page} >
                            <Main getValue={props.getValue} setShowDemo={setShowDemo} selectedLanguage={props.selectedLanguage}/>    
                        </div>
                        <div id={'about-product'} className={s.Page}>
                            <AboutProduct getValue={props.getValue} selectedLanguage={props.selectedLanguage}/>
                        </div>
                        <div id={'situable-for'} className={s.Page} >
                            <SituableFor getValue={props.getValue} situableBlocks={props.situableBlocks} setShowDemo={setShowDemo}/>
                        </div>
                        <div className={s.trigger}>
                            <InfoSource getValue={props.getValue}/>
                        </div>
                        <div id={'how-works'} className={s.Page}>
                            <DemonstrationProduct demoMenu={props.demoMenu} demoContent={props.demoContent} getValue={props.getValue} setShowDemo={setShowDemo}/>
                        </div>
                        <div className={s.trigger}>
                            <MediamonitoringOnline getValue={props.getValue} mediaBlocks={props.mediaBlocks}/>
                        </div>
                        <div id={'advantages'} className={s.Page}>
                            <Advantages getValue={props.getValue} advantagesMenu={props.advantagesMenu} setShowDemo={setShowDemo}/>
                        </div>
                        {/*<div className={s.trigger}>
                            <Partners getValue={props.getValue} />
                        </div>*/}
                        <div id={'contacts'} className={s.Page} /*style={{height: pageHeight, minHeight: pageHeight}}*/>
                            <ContactsPage 
                                            getValue={props.getValue} 
                                            sendMessage={props.sendMessage} 
                                            isDemoSuccess={props.isDemoSuccess} 
                                            setIsDemoSuccess={props.setIsDemoSuccess}
                                            setMenuActive={props.setMenuActive}
                                            selectedLanguage={props.selectedLanguage}
                            />
                        </div>
                    </div>
    const page = <div className={s.EchoPage}>
        <div className={s.Auth}>
            <Signin 
                    getValue={props.getValue} 
                    signin={setSignIn}                             
                    showModal={props.showModal} 
                    resetPassword={props.resetPassword} 
                    errorInResetPassword={props.errorInResetPassword} 
                    setErrorInResetPassword={props.setErrorInResetPassword}
                    loginError={props.loginError}
                    setErrorInLogin={props.setErrorInLogin}
                    unAuthorizedLanguage={props.unAuthorizedLanguage}
                    setSelectedLanguage={props.setSelectedLanguage}
                />
        </div>
        
    </div>

    const getPage = (type) => {
        switch(type){
            case 'AUTHORIZATION':
                return page;
            case 'OFFERT':
                return <Offert getValue={props.getValue} selectedLanguage={props.selectedLanguage}/>
            case 'PRIVACY_POLICY':
                return <PrivacyPolicy getValue={props.getValue} selectedLanguage={props.selectedLanguage}/>
            default:
                return pages;
        }
    }

    return(
        <React.Fragment>
            {
                getPage(props.activeMenu)
            }
        </React.Fragment>
    )
}

export default Pages;